"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var EPG_1 = require("stremio/common/EPG");
var Image_1 = __importDefault(require("stremio/components/Image"));
var ProgramInfo_less_1 = __importDefault(require("./ProgramInfo.less"));
var ProgramInfo = function (_a) {
    var _b;
    var program = _a.program, now = _a.now;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var progress = (0, EPG_1.getEpgProgress)(program, now);
    var date = program.startTime.toLocaleDateString(i18n.language, { weekday: 'long', month: 'short', day: 'numeric' });
    return (react_1.default.createElement("div", { className: ProgramInfo_less_1.default['info'] },
        react_1.default.createElement("div", { className: ProgramInfo_less_1.default['channel'] },
            program.channelLogo &&
                react_1.default.createElement(Image_1.default, { className: ProgramInfo_less_1.default['channel-logo'], src: program.channelLogo, alt: '' }),
            react_1.default.createElement("span", null, program.channelName)),
        react_1.default.createElement("div", { className: ProgramInfo_less_1.default['status-line'] },
            react_1.default.createElement("span", { className: progress !== null ? ProgramInfo_less_1.default['live'] : ProgramInfo_less_1.default['status'] }, progress !== null ?
                t('LIVE_TV_ON_NOW', { defaultValue: 'On now' })
                :
                    program.startTime.getTime() > now ? t('UPCOMING') : t('AIRED')),
            react_1.default.createElement("span", null, date)),
        react_1.default.createElement("div", { className: ProgramInfo_less_1.default['time'] },
            react_1.default.createElement(react_2.default, { name: 'clock', className: ProgramInfo_less_1.default['time-icon'] }),
            react_1.default.createElement("span", null, (0, EPG_1.formatEpgTimeRange)(program.startTime, program.endTime, i18n.language)),
            program.runtime &&
                react_1.default.createElement("span", { className: ProgramInfo_less_1.default['runtime'] }, program.runtime), (_b = program.ratings) === null || _b === void 0 ? void 0 :
            _b.filter(function (rating) { return rating.value.trim(); }).map(function (rating, index) { return (react_1.default.createElement("span", { key: "".concat(rating.system, ":").concat(rating.value, ":").concat(index), className: ProgramInfo_less_1.default['content-rating'], title: rating.system ? "".concat(rating.system, ": ").concat(rating.value) : rating.value }, rating.icon ?
                react_1.default.createElement(Image_1.default, { src: rating.icon, alt: rating.value, renderFallback: function () { return rating.value; } })
                :
                    rating.value)); })),
        progress !== null &&
            react_1.default.createElement("div", { className: ProgramInfo_less_1.default['progress'] },
                react_1.default.createElement("div", { style: { width: "".concat(progress, "%") } }))));
};
exports.default = ProgramInfo;
